<template>
  <div class="basic_con">
    <Frame title="逾期情况">
      <template slot="contentSlot">
        <div class="con_wrapper">
          <div class="item_con">
            <div class="title">期数</div>
            <div class="num">{{dataInfo.count}}</div>
          </div>
          <div class="item_con">
            <div class="title">天数</div>
            <div class="num">{{dataInfo.days}}</div>
          </div>
          <div class="item_con">
            <div class="title">总金额（元）</div>
            <div class="num money">{{dataInfo.amount}}</div>
          </div>
        </div>
      </template>
    </Frame>

    <Frame title="租息情况">
      <template slot="contentSlot">
        <div class="con_wrapper">
          <div class="item_con">
            <div class="title">未还租息</div>
            <div class="num zx_con">0</div>
          </div>
          <div class="item_con">
            <div class="title">敞口</div>
            <div class="num zx_con">0</div>
          </div>
        </div>
      </template>
    </Frame>
  </div>
</template>

<script>
import Frame from "../../frame.vue";
import { getOverdueInfoByCustId } from "@/api/factoring/factoringCustomer";

export default {
  name: "overdueSituation",
  components: {
    Frame,
  },
  data() {
    return {
      dataInfo:{}
    };
  },
  props: {
   
  },
  async mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      let res = await getOverdueInfoByCustId({ custId: this.$route.params.id });
      if (res.data.code == 200) {
        this.dataInfo = res.data.data;
      } else {
        this.$message.error(res.data.message);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.basic_con {
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
  border-radius: 10px;
  // aspect-ratio: 1/1;
  height: 397px;
  display: flex;
  flex-direction: column;
}
.con_wrapper {
  text-align: center;
  // padding: 0 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // padding-bottom: 50px;

  .item_con {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .title {
      font-weight: 400;
      font-style: normal;
      font-size: 14px;
      color: rgba(102, 102, 102, 0.8);
      text-align: center;
    }
    .num {
      font-weight: 400;
      font-style: normal;
      font-size: 20px;
      color: #fd8686;
    }
    .money {
      background: #fd8686;
      color: #ffffff;
      padding: 0 4px;
      border-radius: 5px;
    }
  }
}

.zx_con {
  color: #333333 !important;
  font-size: 14px !important;
}
.frame {
  flex: 1;
}
</style>

